import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Label, Collapse,Row,Col } from 'reactstrap';
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
Chart.register(ChartDataLabels);

const ActionDue = ({ ActionDueList, elementRef, OngoingActionDueList }) => {
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const labels = ActionDueList.labelsList;
    const data = ActionDueList.costList;
    const data1 = OngoingActionDueList.costList;
    const dataBar = {
        labels: labels,
        datasets: [
            {
                label: "#Ongoing Actions",
                backgroundColor: "#198754",
                borderColor: "#198754",
                borderWidth: 1,
                hoverBackgroundColor: "#198754",
                hoverBorderColor: "#198754",
                data: data1,
            },
            {
                label: "#Improvement Actions",
                backgroundColor: "#1A959E",
                borderColor: "#1A959E",
                borderWidth: 1,
                hoverBackgroundColor: "#1A959E",
                hoverBorderColor: "#1A959E",
                data: data,
            }
        ]
    };

    const options = {
        plugins: {
            datalabels: {
                display: true,
                color: "#0D535D",
                formatter: function (value) {
                    return value == 0 ? '' : value
                },
                anchor: "end",
                offset: -20,
                align: "start"
            },
            legend: {
                display: true
            },
            
        },
        scales: {
            // to remove the labels
            x: {
                ticks: {
                    display: true,
                    color: "#0D535D",
                    font: {
                        size: 14,
                        weight: "bold" 
                    }
                },

                // to remove the x-axis grid
                grid: {
                    drawBorder: false,
                    display: false,
                },
            },
            // to remove the y-axis labels
            y: {
                ticks: {
                    display: false,
                    beginAtZero: true,
                    stepSize: 5
                },
                // to remove the y-axis grid
                grid: {
                    drawBorder: false,
                    display: true,
                },
            },
        },
    }

    const labels1 = OngoingActionDueList.labelsList;
    

    const dataBar1 = {
        labels: labels1,
        datasets: [
            {
                label: "#Ongoing Actions",
                backgroundColor: "#1A959E",
                borderColor: "#1A959E",
                borderWidth: 1,
                hoverBackgroundColor: "#1A959E",
                hoverBorderColor: "#1A959E",
                data: data1,
                barThickness: 33,
            }
        ]
    };

    const options1 = {
        plugins: {
            datalabels: {
                display: true,
                color: "#0D535D",
                formatter: function (value) {
                    return value == 0 ? '' : value
                },
                anchor: "end",
                offset: -20,
                align: "start"
            },
            legend: {
                display: true
            },

        },
        scales: {
            // to remove the labels
            x: {
                ticks: {
                    display: true,
                    color: "#0D535D",
                    font: {
                        size: 14,
                        weight: "bold"
                    }
                },

                // to remove the x-axis grid
                grid: {
                    drawBorder: false,
                    display: false,
                },
            },
            // to remove the y-axis labels
            y: {
                ticks: {
                    display: false,
                },
                // to remove the y-axis grid
                grid: {
                    drawBorder: false,
                    display: true,
                },
            },
        },
    }

    return (
        <Card className="my-4 ">
            <CardHeader className="card-header-dark-click" onClick={toggle}>
                <Row>
                    <Col sm="11"><h5>Action Due - next 5 year
                    </h5></Col>
                    <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>
            <Collapse isOpen={isOpen}>
                <CardBody>
                    <div ref={elementRef}>
                        <Row>
                            {/*<Col sm="4">*/}
                            {/*    <Bar data={dataBar1} options={options1} width={100} height={50} />*/}
                            {/*</Col>*/}
                            <Col sm="12">
                                <Bar data={dataBar} options={options} width={100} height={50} />
                            </Col>
                        </Row>    
                    </div>
                    <br />
                    <Label className="form-label-default">
                        Total Estimated Improvement Actions Cost ${ActionDueList.totalEstimatedCost}
                    </Label>
                </CardBody>
            </Collapse>
            
        </Card>
    )
}
export default ActionDue